import { Divider, Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useMemo } from "react";
import { scrollbarStyle } from "../../../shared/dashboard";
import { Workspace } from "../../../types/files";
import useWorkspaces from "../../../hooks/useWorkspaces";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import classNames from "classnames";

const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative',
        width: '100%',
        height: 'fit-content',
        marginTop: 16,
        padding: 16,
        paddingRight: 24,
        overflowX: 'hidden',
        overflowY: 'auto',
        borderRadius: 16,
        backgroundColor: '#fff',
        border: `1px solid ${theme.colors.neutral['100']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2), 0px 5px 8px 0px rgba(16, 24, 40,0.14), 0px 1px 14px 0px rgba(16, 24, 40,0.12)',
        transition: '0.05s ease-in-out',
        ...scrollbarStyle,
    },
    title: {
        fontFamily: 'Inter',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        color: theme.colors.neutral['900'],
    },
    label: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-all',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    sublabel: {
        fontWeight: 'bold',
        color: theme.colors.neutral['600'],
    },
}));

const InvestorPreview: React.FC<{ sharedWorkspace: Workspace }> = ({ sharedWorkspace }) => {
    const classes = useStyles();
    const { acceptedInvestors } = useWorkspaces();

    const investors = useMemo(() =>
        acceptedInvestors.filter((investor) => investor.workspaceId === sharedWorkspace.id)
    , [acceptedInvestors, sharedWorkspace.id]);

    return (<>
        <Stack className={classes.card} spacing={1} alignItems="flex-start" justifyContent="flex-start" width="100%">
            <Typography className={classes.title}>
                {`Investors in ${sharedWorkspace.name}`}
            </Typography>
            <Divider sx={{ width: '100%' }} />
            <Stack direction="column" spacing={2} alignItems="center" justifyContent="flex-start" width="100%" py={1}>
                {investors.slice(0, 3).map((investor, i) => (
                    <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="flex-start" width="100%"
                        key={'investors-preview-70-' + i}>
                        <PersonOutlineOutlinedIcon sx={{ width: 24, height: 24, fill: "rgb(163, 167, 172)" }} />
                        <Stack direction="column" alignItems="flex-start" justifyContent="center">
                            {/* <Typography className={classes.label}>
                                {investor.name}
                            </Typography> */}
                            <Typography className={classNames(classes.label, classes.sublabel)}>
                                {investor.email}
                            </Typography>
                        </Stack>
                    </Stack>
                ))}
            </Stack>
            {investors.length > 3 && (
                <Typography className={classes.title} fontSize="0.95rem !important" color="#666666 !important">
                    {`+ ${investors.length - 3} other investor${investors.length - 3 > 1 ? 's' : ''}`}
                </Typography>
            )}
        </Stack>
    </>);
}

export default InvestorPreview;